export default () => import(/* webpackChunkName: 'coffee/activities/luckincard/homeV2' */ './HomeV2');
